import { render, staticRenderFns } from "./insufficient.vue?vue&type=template&id=e2563e04&scoped=true&"
import script from "./insufficient.vue?vue&type=script&lang=js&"
export * from "./insufficient.vue?vue&type=script&lang=js&"
import style0 from "./insufficient.vue?vue&type=style&index=0&id=e2563e04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2563e04",
  null
  
)

export default component.exports